import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63e0bbba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-dialog-header"
}
const _hoisted_2 = { class: "p-dialog-title" }
const _hoisted_3 = { class: "p-dialog-header-icons" }
const _hoisted_4 = {
  key: 2,
  class: "p-dialog-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!

  return ($data.modalInfoVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([$options.overlayClass, "p-dialog-mask xdialog"]),
        style: _normalizeStyle({display: 'flex', opacity: $props.opacity})
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(!$props.fullTransparent ? 'p-dialog' : '')
        }, [
          (_ctx.$slots.header || $props.showCloseButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "header", {}, undefined, true)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  ($props.showCloseButton)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-dialog-header-icon p-dialog-header-close p-link",
                        icon: "pi pi-times",
                        onClick: $options.hide
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (!!_ctx.$slots.header_toolbar_left || !!_ctx.$slots.header_toolbar_right)
            ? (_openBlock(), _createBlock(_component_Toolbar, {
                key: 1,
                class: "w-full",
                style: {"border":"0px"}
              }, {
                start: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "header_toolbar_left", {}, undefined, true)
                ]),
                end: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "header_toolbar_right", {}, undefined, true)
                ]),
                _: 3
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(!$props.fullTransparent ? 'p-dialog-content' : ''),
            style: {overflowX: 'hidden'}
          }, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 2),
          (!$props.hideFooter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "footerLeftOfHide", {}, undefined, true),
                _renderSlot(_ctx.$slots, "footer", {}, () => [
                  _createVNode(_component_Button, {
                    class: "p-button-outlined ml-2",
                    icon: "pi pi-times p-button-success",
                    label: "Закрыть",
                    onClick: $options.hide
                  }, null, 8, ["onClick"])
                ], true)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ], 6))
    : _createCommentVNode("", true)
}